// We need the following rate type guards because TypeScript can't narrow `rate` based on a
// narrowing of `rate.service`. If we wanted to this inline, we'd have to construct a new object,
// like so.
//
// ```typescript
// if (rate.service.type === 'lpc') {
//   const thisFails: App.LpcPropertyRate = rate
//   const thisWorks: App.LpcPropertyRate = { ...rate, service: rate.service }
// }
// ```
//
// For further details, see <https://github.com/microsoft/TypeScript/issues/42384>.

export function isLpcRate(rate: App.PropertyRate): rate is App.LpcPropertyRate {
  return rate.service.type === 'lpc'
}

export function isBedbankRate(rate: App.PropertyRate): rate is App.BedbankPropertyRate {
  return rate.service.type === 'bedbank'
}
